import { Box } from '@pangolindex/components'
import styled from 'styled-components'

export const Root = styled(Box)`
  width: 100%;
  min-width: 400px;
  position: relative;
  overflow: hidden;
`
